var map = {
	"./font-italic.svg": 2825,
	"./font-normal.svg": 41636,
	"./icon-form.svg": 12479,
	"./spjj.svg": 73091,
	"./sptg.svg": 59848,
	"./spz.svg": 74151,
	"./ycx.svg": 82353,
	"./ygq.svg": 59263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71309;